// Версии сообщения не откатываются более старым HTTP/WS-ответом.
export function mergeMessages(previous, incoming) {
  const map = new Map(previous.map((message) => [Number(message.id), message]));
  for (const message of incoming || []) {
    const id = Number(message.id);
    if (!id) continue;
    const old = map.get(id);
    const oldVersion = Date.parse(old?.date_update || old?.date_create || '') || 0;
    const newVersion = Date.parse(message.date_update || message.date_create || '') || 0;
    if (old && newVersion < oldVersion) continue;
    map.set(id, { ...old, ...message, is_read: !!(old?.is_read || message.is_read) });
  }
  return [...map.values()].sort((a, b) => Number(a.id) - Number(b.id));
}

export function newMessageId() {
  if (globalThis.crypto?.randomUUID) return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}